import {useState} from 'react';

import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {connect} from 'react-redux';

import CustomTextField from './components/common/CustomTextField';
import {authorize} from './redux/reducers/stagingGateway';

const AuthorizedGate = props => {
  const {isAuthorized, correctPassword, onAuthorize} = props;
  const [password, setPassword] = useState('');
  const handleSubmit = (e) => {
    if (password === correctPassword) onAuthorize();
  };
  // if (!isAuthorized) {
  //   return (
  //     <Container maxWidth='xs'>
  //       <Stack spacing={1} padding={4}>
  //         <Typography>movement-x.com is down for scheduled system maintenance. We'll be back shortly!</Typography>
  //         <CustomTextField
  //           label='Password'
  //           onChange={(e) => setPassword(e.target.value)}
  //           type='password'
  //           value={password}
  //           helperText='If you are a MovementX team member, enter the password to access the site.'
  //         />
  //         <Button variant='contained' onClick={handleSubmit}>Enter Site</Button>
  //       </Stack>
  //     </Container>
  //   );
  // }
  return <>{props.children}</>
};

const mapState = state => ({
  correctPassword: state?.stagingGateway?.correctPassword,
  isAuthorized: state?.stagingGateway?.isAuthorized,
});

const mapDispatch = dispatch => ({
  onAuthorize: () => dispatch(authorize()),
});

export default connect(mapState, mapDispatch)(AuthorizedGate);